<div class="create-label-dialog">
  <app-popup-top-line></app-popup-top-line>
  <div class="create-label-dialog-header">
    <div class="title">
      {{ 'createLabelDialog.createLabelTitle' | labelsProvider }}
    </div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="create-label-dialog-body">
    <div class="textarea textarea-show">
      <textarea
        type="text"
        maxlength="20"
        placeholder="Enter label name"
        disabled
        value="{{ name }}"
        [ngStyle]="{
          'background-color': getLabelTransparentBackgroundColor(),
        }"
      ></textarea>
    </div>

    <div class="create-label-dialog-body-title">
      {{ 'createLabelDialog.newLabelNameTitle' | labelsProvider }}
    </div>
    <div class="textarea">
      <textarea type="text" maxlength="30" placeholder="Enter label name" (input)="onNameChange($event)"></textarea>
    </div>

    <div class="create-label-dialog-body-title">
      {{ 'createLabelDialog.newLabelColorTitle' | labelsProvider }}
    </div>
    <input type="color" value="{{ color }}" class="color-picker" (input)="onColorChange($event)" />
    <div class="section-divider"></div>
  </div>
  <div class="create-label-dialog-footer">
    <button class="create" (click)="createButtonClick()" [ngClass]="{ 'create-disabled': !name }">
      <span>{{ 'createLabelDialog.createButtonText' | labelsProvider }}</span>
    </button>
  </div>
</div>
